import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild, ElementRef } from '@angular/core';

@Component({
  selector: 'app-single-select-dropdown2',
  templateUrl: './single-select-dropdown.component.html',
  styleUrls: ['./single-select-dropdown.component.scss'],
  standalone: false
})
export class SingleSelectDropdownComponent implements OnInit {
  @Input() clicked: any;
  @Input() items: any[];
  @Input() label: string;
  @Input() showMore: boolean;
  @Input() requireApply: boolean;
  @Input() searchFilterActive: boolean | null;
  @Input() borderRadius: string = '0.8rem';
  @Input() alternateLook: boolean = false;
  @Input() selectedItem: any;
  @Input() id: string = '';
  @Input() disabled: boolean = false;
  @Input() textColor: string | null = null;

  @ViewChild('dropdownButton') dropdownButton!: ElementRef<HTMLButtonElement>;

  @Output() shareSelectedItem = new EventEmitter();
  @Output() applyFilterEmitter = new EventEmitter();
  @Output() filterValue = new EventEmitter();

  currentSelected: any;
  seletedLabel: any;
  public searchValue: any;

  constructor() { }

  ngOnInit(): void {
  }

  applySearchFilter(value: any) {
    this.filterValue.emit(value);
  }

ngOnChanges(changes: SimpleChanges) {
  if (changes['selectedItem']) {
    this.currentSelected = this.selectedItem;
    this.seletedLabel = this.selectedItem?.name ?? '';
  }

  if (changes['clicked'] && changes['clicked'].currentValue) {
    setTimeout(() => this.openDropdown(), 0);
  }
}

getSelectedValue(id: number) {
  this.currentSelected = this.items.find(x => x.id === id);

  this.seletedLabel = this.currentSelected?.name ?? '';

  this.shareSelectedItem.emit(this.currentSelected);
  this.applyFilter();
}


  applyFilter() {
    this.applyFilterEmitter.emit();
  }

  private openDropdown() {
    if (this.disabled || !this.items || this.items.length === 0) return;
    const btn = this.dropdownButton?.nativeElement;
    if (btn) {
      btn.click();
    }
  }
}
